const baseDomain = `${window.location.protocol}//${window.location.host}`;
const baseUrl = `${baseDomain}/roboroy/api/v1`; // this is the baseurl for API calls only
const flaskUrl = `${baseDomain}/roboroy/api/v1`; // for requests to flask server such as resume upload use this.
const regularUrl = `${baseDomain}/api`; // for requests to flask server such as resume upload use this.
const v2BaseUrl =`${baseDomain}/roboroy/api/v2`

// http://localhost:3000/api

export { baseUrl, flaskUrl, regularUrl, v2BaseUrl };
